import { Box, Paper, createTheme } from "@mui/material";

const theme = createTheme();

const responsive_card = {
  [theme.breakpoints.down("lg")]: {
    maxWidth: "100% !important",
  },
};

const CardUI = ({
  children,
  maxWidth = 540,
  dashboard = false,
  responsive = "false",
  height,
  maxHeight,
  overflow,
  paddingTop = "86px",
  padding = "68px 40px",
  borderRadius = "8px",
  boxShadow = "0px 2px 16px 0px rgba(0, 0, 0, 0.08)",
  paddingBottom,
  border,
}) => {
  return (
    <Paper
      // style={responsive === "true" ? responsive_card : {}}
      sx={{
        maxWidth: maxWidth,
        width: "100%",
        borderRadius: borderRadius,
        padding: dashboard ? "32px" : padding,
        paddingTop: dashboard ? "32px" : paddingTop,
        WebkitBoxShadow: boxShadow,
        boxShadow: boxShadow,
        border: border && border,
        background: "#fff",
        height: height && height,
        maxHeight: maxHeight && maxHeight,
        overflow: overflow ? overflow : dashboard ? "auto" : "inherit",
        position: "relative",
        paddingBottom: paddingBottom && paddingBottom,
        display: maxHeight || height ? "flex" : undefined,
        flexDirection: maxHeight || height ? "column" : undefined,
        ...(responsive === "true" && {
          "@media (max-width:1199.95px)": {
            maxWidth: "100% !important",
          },
        }),
      }}
    >
      {children}
    </Paper>
  );
};

export default CardUI;
